import React from "react"
import { Button, Row } from "react-bootstrap"
import Modal from "../../../../../_components/Modal"
import styled from "styled-components"
import { getMaxCode } from "../../../../../api/products"
import { bindActionCreators } from 'redux';
import { connect } from "react-redux";
import { setNcm, setCfop } from '@taxes/actions'
import {
    setBaseProductName,
    setBaseProductBarcode,
    setBaseProductPrice,
    // setBaseProductInternalCode,
    setMaskPrice
} from '../../../../../components/pages/products/base/actions'
import { SelectICMS } from '@taxes'
import { notification } from 'antd'
import { saveProduct } from "../../../../../components/pages/products/utils"
import CurrencyInput from "react-currency-input"

const ContainerDragAndDrop = styled.div`
    display: flex
    justify-content: center
    align-self: center
    max-width: 300px
    paddingTop: 30px
    cursor: pointer
    border: 3px dotted #ebebeb

    i {
        font-size: 4em
        font-weight: bold
    } 

`

import { showSnackBar } from "../../../../../utils"
import { importNFEData } from "../../../../../api/products"
function ImportXML(props) {

    const [selectedXML, setSelectedXML] = React.useState({})
    const [showModal, setShowModal] = React.useState(false)
    const [allowedImport, setAllowedImport] = React.useState(false)
    const [error, setError] = React.useState('')
    const [disabled, setDisabled] = React.useState(false)
    const [importedProducts, setImportedProducts] = React.useState([])
    const [modalProducts, setModalProducts] = React.useState(false)
    const [costList, setCostList] = React.useState([])


    function containsUnicodeCharacter(input) {
        for (let i = 0; i < input.length; i++) {

            if (input.charCodeAt(i) > 127 && !/[a-zA-Zçáéíóúâêôãõ]/.test(input[i])) {
                return true;
            }
        }
        return false;
    }

    function onSelectFile(e) {
        // console.log(e.target.files);

        if (e.target.files[0].type !== 'text/xml') {
            setError('Arquivo inválido! Selecione um arquivo XML válido.')
            setSelectedXML(e.target.files[0])
            setAllowedImport(false)
            return
        }

        setError('')
        setSelectedXML(e.target.files[0])
        setAllowedImport(true)
    }
    function click() {
        const inputFile = document.getElementById("import-xml-nfe-laksjdalsi-askdjhasd")

        inputFile.value = ''
        inputFile.click()
        // showSnackBar("Mensgem", "info")
    }

    function openModal() {
        setSelectedXML({})
        if (importedProducts.length) {
            setModalProducts(true)
        } else {
            setShowModal(true)
        }
    }

    function importData() {

        importNFEData(selectedXML, 'xml')
            .then(response => {
                // console.log(response.itens)
                setImportedProducts(response.itens)
                setDisabled(true)
                setShowModal(false)
                setModalProducts(true)
                setError('')

            })
            .catch(err => {
                console.log(err)

                setError('Erro no XML! Selecione um XML Válido.')
            })
    }

    function setIcmsItens(icms) {


        let temp = importedProducts

        for (let i = 0; i < temp.length; i++) {
            temp[i].icms = icms
            if (temp[i].icms.name == 'Selecione o icms') {
                setDisabled(true)
            }
            else {
                setDisabled(false)
            }
        }
        setImportedProducts(temp)
    }
    async function createProduct() {

        let product_list = []
        const payload = product => {
            notification.open({
                type: "success",
                message: "Produto(s) cadastrado(s)",
                description: <p>
                    <span>Produto(s) cadastrado(s) com sucesso</span>
                </p>
            })
            setTimeout(() => {
                window.location.href = `/products`
            }, 500)
        }

        function errorPayload(err) {

            let data = JSON.parse(err.response)
            for (let i = 0; i < data.length; i++) {
                const element = data[i];
                if (element.code[0]) {
                    showSnackBar('O campo <cProd/> precisa ser único.')
                }
            }
        }
        let maxCode = await getMaxCode()
        console.log(typeof maxCode.max_code)
        for (let i = 0; i < importedProducts.length; i++) {
            console.log('importedProducts', importedProducts)


            let temp = {

                "ref_code": maxCode.max_code + i + 1,
                "name": importedProducts[i].descricao,
                "barcode": importedProducts[i].barcode,
                "unit": importedProducts[i].unidade.id,
                "price": importedProducts[i].valor_venda,
                "cost": importedProducts[i].valor_custo,
                "fiscal": {
                    "ncm": importedProducts[i].ncm.id,
                    "cfop": importedProducts[i].cfop.id,
                    "template_icms": importedProducts[i].icms.id
                }
            }
            if (containsUnicodeCharacter(temp.name) || containsUnicodeCharacter(temp.ref_code)) {
                showSnackBar('O campo "Codigo" e "Descricao" não podem conter caracteres especiais.')
                return true
            } else {
                product_list.push(temp)
            }
            console.log('product_list', product_list)

        }
        saveProduct(product_list, payload, errorPayload, true)
    }

    function EditValue(props) {
        return <div>
            <CurrencyInput
                name="price"
                value={props.value}
                prefix="R$ "
                decimalSeparator="."
                onChange={(a, b, c) => {
                    let tempList = importedProducts
                    console.log(typeof props.value)
                    console.log(a, b, c)
                    tempList[props.index].valor_venda = b
                    setImportedProducts(tempList)
                }}
                className="form-control"
            />
        </div>
    }

    return <div>
        <input
            accept="text/xml"
            onChange={onSelectFile}
            id="import-xml-nfe-laksjdalsi-askdjhasd"
            type="file"
            className="d-none" />
        <Button onClick={openModal}>
            Importar via XML
        </Button>
        <Modal title="Importar produto via XML de NFe" show={showModal} onHide={() => setShowModal(false)}>


            {selectedXML.name && selectedXML.size <= 201000 ? <div>
                {error.length ? <h4 className="text-danger text-center" >{error}</h4> : ''}
                <h3 className="text-center" >{selectedXML.name}</h3>
            </div> :
                <div className="d-flex justify-content-center w-100 flex-column">
                    <ContainerDragAndDrop onClick={click}>
                        <i className="fas fa-file-upload text-info"></i>
                    </ContainerDragAndDrop>
                    <h3 className="text-info text-center" >Selecione um XML</h3>
                </div>
            }
            {selectedXML.size >= 201000 ? <h2 className="text-center font-bold">Arquivo muito pesado! (Max. de 200kB)
                <br />
                fale com o <a target="_blank" href="https://wa.me/5511966466526?&text=teste+espaço">Suporte</a> para mais informações.</h2>
                :
                <div className="d-flex flex-row-reverse">
                <Button disabled={!allowedImport} onClick={importData}>Importar</Button>
            </div>
            }

        </Modal>

        <Modal title="Produtos Encontrados" show={modalProducts} onHide={() => setModalProducts(false)}>
            <table class="table table-responsive-sm table-hover">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Nome</th>
                        <th scope="col">Preço de venda</th>
                        <th scope="col">Preço de custo</th>
                        <th scope="col">NCM</th>
                        <th scope="col">CFOP</th>
                    </tr>
                </thead>
                <tbody>
                    {importedProducts.map((prod, _) => <tr style={{ cursor: 'pointer' }} key={`imported_${_}`}>
                        <td scope="row">{_ + 1}</td>
                        <td>{prod.descricao ? prod.descricao : 'N/A'}</td>
                        <td><EditValue index={_} value={prod.valor_venda} /></td>
                        <td>R$ {prod.valor_custo ? prod.valor_custo : 'N/A'}</td>
                        <td>{prod.ncm ? prod.ncm.code : 'N/A'}</td>
                        <td>{prod.cfop ? prod.cfop.code : 'N/A'}</td>
                    </tr>)}
                </tbody>
            </table>
            <Row className="justify-content-between col-12" >

                <SelectICMS onChangeIcms={setIcmsItens} />

                <Button onClick={() => { createProduct() }} disabled={disabled} style={{ flexDirection: 'column', alignSelf: 'flex-end' }}>Cadastrar {importedProducts.length > 1 ? 'itens' : 'item'}</Button>

                {/* <div style={{ flexDirection: 'column', alignSelf: 'flex-end' }}>
                    <Button className="mx-3" onClick={() => {
                        setImportedProducts([])
                        setModalProducts(false)
                        setShowModal(true)
                        click()
                    }}>Selecionar outro XML</Button>
                </div> */}
            </Row>
        </Modal>
    </div>
}

const mapStateToProps = state => ({})
const mapDispatchToProps = disptch => bindActionCreators({
    setBaseProductName,
    // setBaseProductBarcode,
    setBaseProductPrice,
    // setBaseProductInternalCode,
    setMaskPrice,
    setNcm, setCfop
}, disptch);

export default connect(mapStateToProps, mapDispatchToProps)(ImportXML)


// WEBPACK FOOTER //
// ./src/views/AppViews/Products/imports/NFeXML/index.jsx